import { GetRequest, PostRequest, PutRequest, DeleteRequest } from "./HttpService";

export const getSubscriptionStatus = async () => {
  return await GetRequest("/Subscription/status");
};

export const getSubscriptionPlans = async () => {
  return await GetRequest("/Subscription/plans");
};

export const createSubscriptionPlan = async (plan) => {
  const response = await PostRequest("/Subscription/plans", plan);
  return response.json();
};

export const updateSubscriptionPlan = async (id, plan) => {
  const response = await PutRequest("/Subscription/plans", plan, id);
  return response.json();
};

export const deleteSubscriptionPlan = async (id) => {
  return await DeleteRequest("/Subscription/plans", id);
};

export const requestSubscriptionPayment = async (subPlanId) => {
  return await GetRequest("/Subscription/request-payment", subPlanId);
};

export const verifySubscriptionPayment = async (authority) => {
  return await PostRequest(
    "/Subscription/verify-sub-payment",
    {},
    authority
  );
};
